// extracted by mini-css-extract-plugin
export default {"container":"TimeClockNote_container__1Mfd4","listNote":"TimeClockNote_listNote__aT17B","noDataAvailable":"TimeClockNote_noDataAvailable__h5kwi"};